export default "__VITE_ASSET__TYkaABsj__"